function Footer() {
  return (
    <footer className="mt-auto py-3 bg-gray-800">
      <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-white text-center">Copyright 2024 農林中央金庫健康保険組合</p>
      </div>
    </footer>
  );
}

export default Footer;